import actionTypes from '../../action-types'

export default (payload) => ({
  type: actionTypes.NOTIFICATION_CENTER.REMOVE,
  payload,
})
